import { gql, TypedDocumentNode } from '@apollo/client';
import {
  DefaultApiResponse,
  DefaultArg,
  transactionErrorFragment,
} from '@libs/graphql';
import { TransactionErrorResponse } from 'src/types';

type CalculateCardDepositRes = {
  fee: number;
  roundedAmount: number;
  totalAmount: number;
  feePercentage: number;
  error?: TransactionErrorResponse;
};
export type CalculateCardDepositArgs = {
  amount: number;
};

export type CalculateCardDepositResponse = {
  calculateCardDeposit: DefaultApiResponse<CalculateCardDepositRes>;
};

export const calculateCardDepositQuery: TypedDocumentNode<
  CalculateCardDepositResponse,
  DefaultArg<CalculateCardDepositArgs>
> = gql`
  query CalculateCardDeposit($record: CalculateCardDepositRecord!) {
    calculateCardDeposit(record: $record) {
      fee
      roundedAmount
      totalAmount
      feePercentage
      error {
        ...transactionErrorFields
      }
    }
  }
  ${transactionErrorFragment}
`;
